// extracted by mini-css-extract-plugin
export default {"root":"About_root__oHiOg","container":"About_container__ePLGO","heading":"About_heading__UZ7K6","paragraph":"About_paragraph__n2THF"};